import classNames from "classnames";
import { Cell, Row, flexRender } from "react-table-8.10.7";
import { TaskDeadlineOverviewItem } from "types/Models/task";
import { getIsTaskCompleted } from "./EntityTaskTableColumns";
import { FilingActionCta } from "./FilingActionCta";

type MobileTaskRowCardProps = {
  row: Row<TaskDeadlineOverviewItem>;
};

// Column ids generated by react-table from the accessors in EntityTaskTableColumns.
const TASK_COLUMN_ID = {
  FILING: "task_title",
  DEADLINE: "deadline_date",
  STATUS: "task_states",
  ETD: "estimated_time_of_delivery",
  OPTIONS: "task_uuid",
} as const;

const renderCell = (cell?: Cell<TaskDeadlineOverviewItem, unknown>) =>
  cell ? flexRender(cell.column.columnDef.cell, cell.getContext()) : null;

export const MobileTaskRowCard = ({ row }: MobileTaskRowCardProps) => {
  const cellsById = Object.fromEntries(
    row.getVisibleCells().map((cell) => [cell.column.id, cell])
  );
  const { openActions } = row.getVisibleCells()[0].getContext().table.options
    .meta as {
    openActions: (taskId: string) => void;
  };

  // Bundled sub-filings indent their title with an arrow; line the rest of
  // the card up under that title.
  const isSubTask = row.depth > 0;
  const etdCell = cellsById[TASK_COLUMN_ID.ETD];

  return (
    <div className="t-flex t-flex-col t-gap-2">
      <div className="t-flex t-items-start t-justify-between t-gap-2">
        <div className="t-min-w-0 t-flex-1">
          {renderCell(cellsById[TASK_COLUMN_ID.FILING])}
        </div>
        <div className="t-flex t-shrink-0 t-items-center t-gap-1">
          <FilingActionCta
            item={row.original}
            isTaskCompleted={getIsTaskCompleted(row.original)}
            onOpenActions={openActions}
            hideEmpty
          />
          {renderCell(cellsById[TASK_COLUMN_ID.OPTIONS])}
        </div>
      </div>

      <div
        className={classNames("t-flex t-flex-col t-items-start t-gap-1.5", {
          "t-pl-8": isSubTask,
        })}
      >
        <div className="t-flex t-flex-wrap t-items-center t-gap-x-4 t-gap-y-1.5">
          {renderCell(cellsById[TASK_COLUMN_ID.STATUS])}
          {renderCell(cellsById[TASK_COLUMN_ID.DEADLINE])}
        </div>
        {etdCell && <div className="t-w-40">{renderCell(etdCell)}</div>}
      </div>
    </div>
  );
};
